import { useEffect } from 'react';
import { Modal, Row, Table } from 'antd';

import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { useCapturePostHog } from '../../../../hooks/useCapturePostHog';
import type { SortedInfo } from '../../../../models/table';
import type { NameTotal } from '../programDashboardSlice';
import type { DashboardModalType } from './modalDashboardSlice';
import { closeDashboardModal, handleModalTableChange } from './modalDashboardSlice';

export const PopulationDistributionModal = <K extends string>({
  open,
  data,
  filtersInfo,
  data_key,
}: {
  open: boolean;
  data: NameTotal<K>[];
  filtersInfo: string;
  data_key: K;
}) => {
  const dispatch = useAppDispatch();
  const { capturePostHogCustomEvent } = useCapturePostHog();
  const sortedInfo = useAppSelector((state) => state.modalDashboardSlice.requestModalParam.sortedInfo);

  const name: string = data_key.charAt(0).toUpperCase() + data_key.replace('_', ' ').slice(1);

  useEffect(() => {
    dispatch(
      handleModalTableChange({
        sorter: {
          columnKey: 'total',
          field: 'total',
          order: 'descend',
        },
      }),
    );
  }, [dispatch]);

  return (
    <Modal
      className="dashboardModal"
      width={'25%'}
      title={`${name} details`}
      open={open}
      onCancel={() => {
        capturePostHogCustomEvent(`${name} close modal`);
        dispatch(closeDashboardModal());
      }}
      mask={{ blur: false, closable: false }}
      footer={null}
    >
      <Row className="filtersInfoRow" justify="space-between" align="middle">
        <p style={{ marginTop: 'auto', marginBottom: 'auto' }}>{filtersInfo}</p>
      </Row>
      <Table
        rowKey={data_key}
        className="dashboardTable"
        style={{ marginBottom: '25px' }}
        columns={[
          {
            title: name,
            dataIndex: data_key,
            key: data_key,
            width: 150,
          },
          {
            title: 'Number of clients',
            dataIndex: 'total',
            key: 'total',
            width: 150,
            sorter: (a, b) => a.total - b.total,
            sortOrder: sortedInfo.field === 'total' ? sortedInfo.order : null,
          },
        ]}
        onChange={(pagination, filters, sorter) => {
          dispatch(handleModalTableChange({ pagination, filters, sorter: sorter as SortedInfo<DashboardModalType> }));
          capturePostHogCustomEvent(`${name} modal table change`);
        }}
        dataSource={data}
        pagination={false}
      />
    </Modal>
  );
};
